import styled from 'styled-components';
import { Grid } from '../../../app/StyleGuide';
import { SmallRoundedIconButton } from '../../../components/Buttons';

export const ActionButton = styled(SmallRoundedIconButton)`
  line-height: ${Grid._4};
  width: ${Grid._10};
`;
